'use client';

import { use } from 'react';
import Link from 'next/link';
import BookList from '@/components/reader/BookList';
import { BIBLE_BOOKS } from '@/lib/constants';

export default function BookPage({
  params,
}: {
  params: Promise<{ book: string }>;
}) {
  const { book: bookParam } = use(params);
  const bookName = decodeURIComponent(bookParam);
  const bookData = BIBLE_BOOKS.find((b) => b.name === bookName);
  const chapterCount = bookData?.chapters || 0;

  return (
    <div className="flex h-screen">
      {/* Book sidebar */}
      <div
        className="w-64 shrink-0 overflow-y-auto p-4"
        style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRight: '1px solid rgba(200, 164, 94, 0.1)',
        }}
      >
        <BookList activeBook={bookName} />
      </div>

      {/* Chapter grid */}
      <div className="flex-1 overflow-y-auto p-8">
        <h1
          className="text-3xl font-semibold mb-2"
          style={{ color: 'var(--text-primary)' }}
        >
          {bookName}
        </h1>
        <p
          className="text-sm mb-8"
          style={{ color: 'var(--text-secondary)' }}
        >
          {chapterCount} chapter{chapterCount !== 1 ? 's' : ''}
          {bookData && (
            <span className="ml-2">
              ({bookData.testament === 'old' ? 'Old' : 'New'} Testament)
            </span>
          )}
        </p>

        <div className="grid grid-cols-5 sm:grid-cols-8 md:grid-cols-10 gap-3">
          {Array.from({ length: chapterCount }, (_, i) => i + 1).map(
            (chapter) => (
              <Link
                key={chapter}
                href={`/reader/${encodeURIComponent(bookName)}/${chapter}`}
                className="flex items-center justify-center aspect-square rounded-xl text-sm font-medium transition-all duration-200"
                style={{
                  backgroundColor: 'var(--bg-card)',
                  color: 'var(--text-primary)',
                  border: '1px solid rgba(200, 164, 94, 0.1)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor =
                    'rgba(200, 164, 94, 0.4)';
                  e.currentTarget.style.color = 'var(--accent-gold)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor =
                    'rgba(200, 164, 94, 0.1)';
                  e.currentTarget.style.color = 'var(--text-primary)';
                }}
              >
                {chapter}
              </Link>
            )
          )}
        </div>
      </div>
    </div>
  );
}
